import type { UnknownArray } from '@ricoh/ria.client.core/types/core/data.type';
import type { Key } from 'swr';

import type { EndpointConfig, EndpointConfigCreator } from './_request.type';

/**
 * Create EndpointConfig.
 *
 * @template TParams Params types.
 * @param {NonNullable<Key>} key Key.
 * @param {EndpointConfigCreator<TParams>} creator Creator.
 *
 * @returns {EndpointConfig<TParams>} EndpointConfig.
 */
export function createEndpointConfig<TParams extends UnknownArray = UnknownArray>(
  key: NonNullable<Key>,
  creator: EndpointConfigCreator<TParams>,
): EndpointConfig<TParams> {
  return Object.assign<EndpointConfig<TParams>>(creator, { key });
}
